<template>
    <div id="app-scale-wrapper">
        <el-container style="height: 100vh; border: 1px;">
            <!-- left -->
            <el-row class="tac">
                <div
                        style="text-align: center; font-size: 9px; background-color:#013263; width:100%; color:#E6A23C;
  border-radius: 0.75rem !important;margin-top:10px;"
                >
                    <br />

                    <router-link to="/chart/RightMain" v-if="isLogoIf">
                        <img
                                src="./assets/main4.png"
                                width="180"
                                height="auto"
                                style="padding: 0px 15px"
                        />
                    </router-link>
                    <router-link to="/chart/RightMain" v-if="isLogoIf173">
                        <img
                                src="./assets/ktngLogo.png"
                                width="180"
                                height="auto"
                                style="padding: 0px 15px"
                        />
                    </router-link>

                    <router-link to="/chart/RightMain" v-if="isLogoIf174">
                        <img
                                src="./assets/globient.png"
                                width="180"
                                height="auto"
                                style="padding: 0px 15px"
                        />
                    </router-link>
                    <br />
                </div>

                <!-- left menu background-color="#545c64" -->
                <el-menu
                        :default-active="this.activeIndex"
                        class="el-menu-vertical-demo"
                        @open="handleOpen"
                        @close="handleClose"
                        background-color="#013263"
                        text-color="#fff"
                        active-text-color="#ffd04b"
                >
                    <hr style=" background-color : white;"
                            width="160"   />

                    <router-link to="/file/fileUpload">
                        <el-menu-item index="1-2" v-if="isMenuVIf[0]"  >
                          <span>
                            <B>
                              <i class="el-icon-files" style="margin-left: 10px"></i>
                               File Upload </B>
                          </span>
                        </el-menu-item>
                    </router-link>



                        <router-link to="/qrCode/List">
                            <el-menu-item index="2-1" v-if="isMenuVIf[0]" >
                                <i class="el-icon-s-order" style="margin-left: 10px"></i>
                                <B>  QR 주문 (주문) </B>
                            </el-menu-item>
                        </router-link>

                        <router-link to="/qrCode/PublishList">
                            <el-menu-item index="2-2" v-if="isMenuVIf[0]" >
                                <B>
                                    <i class="el-icon-printer" style="margin-left: 10px"></i>
                                    QR 발행 (Print) </B>
                            </el-menu-item>
                        </router-link>



                    <hr
                            style=" background-color : transparent;"
                            width="180"
                            v-if="isMenuVIf[0]"
                    />


                    <router-link to="/member/List">
                        <el-menu-item index="7"
                                      v-if="isMenuVIf[0]"
                        >
                      <span><B>
                          <i class="el-icon-user-solid" style="margin-left: 10px"></i>
                         고객정보 관리
                      </B>
                      </span>
                        </el-menu-item>
                    </router-link>

                    <hr
                            style=" background-color : transparent;"
                            width="180"
                            v-if="isMenuVIf[0]"
                    />


                    <router-link to="/data/Report">
                        <el-menu-item index="9-1" v-if="isMenuVIf[3]"
                        >
                        <span><B>
                            <i class="el-icon-location-outline" style="margin-left: 10px"></i>
                           기간별 인증통계
                        </B>
                        </span>
                        </el-menu-item>
                    </router-link>


                    <router-link to="/data/Report2">
                        <el-menu-item index="9-2" v-if="isMenuVIf[3]"
                        >
                        <span><B>
                              <i class="el-icon-location-outline" style="margin-left: 10px"></i>
                           국가별 인증통계
                        </B>
                        </span>
                        </el-menu-item>
                    </router-link>


                    <router-link to="/data/Report3">
                        <el-menu-item index="9-3" v-if="isMenuVIf[3]"
                        >
                        <span><B>
                            <i class="el-icon-location-outline" style="margin-left: 10px"></i>
                           도시별 인증통계
                        </B>
                        </span>
                        </el-menu-item>
                    </router-link>

                    <router-link to="/data/Report4">
                        <el-menu-item index="9-4" v-if="isMenuVIf[3]"
                        >
                        <span><B>
                            <i class="el-icon-location-outline" style="margin-left: 10px"></i>
                           인증코드 통계
                        </B>
                        </span>
                        </el-menu-item>
                    </router-link>


                    <hr
                            style=" background-color : transparent;"
                            width="180"
                            v-if="isMenuVIf[3]"
                    />


                    <router-link to="/qrCode/manisDetailList">
                        <el-menu-item index="15"
                                      v-if="isMenuVIf[2]">
                        <span><B>
                            <i class="el-icon-shopping-cart-full" style="margin-left: 10px"></i>
                          출고 등록
                        </B>
                        </span>
                        </el-menu-item>
                    </router-link>

                    <hr
                            style=" background-color : transparent;"
                            width="180"
                            v-if="isMenuVIf[4]"
                    />


                    <router-link to="/qrCode/classeumDetailList">
                        <el-menu-item index="16"
                                      v-if="isMenuVIf[4]">
                          <span><B>
                              <i class="el-icon-box" style="margin-left: 10px"></i>

                            클라세움 박스매핑
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>

                    <router-link to="/qrCode/classeumWayBill">
                        <el-menu-item index="17"
                                      v-if="isMenuVIf[4]">
                          <span><B>
                              <i class="el-icon-document-copy" style="margin-left: 10px"></i>
                            클라세움 운송장매핑
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>





                    <router-link to="/qrCode/lemonCustomer">
                        <el-menu-item index="18"
                                      v-if="isMenuVIf[5]">
                        <span><B>
                             <i class="el-icon-s-custom" style="margin-left: 10px"></i>
                          레몬보틀 고객정보생성
                        </B>
                        </span>
                        </el-menu-item>
                    </router-link>



                    <router-link to="/qrCode/lemonMapping">
                        <el-menu-item index="19"
                                      v-if="isMenuVIf[5]">
                            <span><B>
                                 <i class="el-icon-box" style="margin-left: 10px"></i>
                              레몬보틀 박스매핑
                            </B>
                            </span>
                        </el-menu-item>
                    </router-link>


                    <router-link to="/qrCode/le2Customer">
                        <el-menu-item index="20"
                                      v-if="isMenuVIf[6]">
                          <span><B>
                              <i class="el-icon-s-custom" style="margin-left: 10px"></i>
                            제네틱 고객정보생성
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>



                    <router-link to="/qrCode/le2Mapping">
                        <el-menu-item index="21"
                                      v-if="isMenuVIf[6]">
                          <span><B>
                              <i class="el-icon-box" style="margin-left: 10px"></i>
                            제네틱 박스매핑
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>


                    <router-link to="/qrCode/nextPlayBoxMapping">
                        <el-menu-item index="22"
                                      v-if="isMenuVIf[7]">
                          <span><B>
                              <i class="el-icon-box" style="margin-left: 10px"></i>
                            넥스트플레이어 박스매핑
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>




                    <router-link to="/qrCode/nextPlayMapping">
                        <el-menu-item index="23"
                                      v-if="isMenuVIf[8]">
                          <span><B>
                               <i class="el-icon-goods" style="margin-left: 10px"></i>

                            넥스트플레이어 판매
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>




                    <router-link to="/qrCode/panartisDetailList">
                        <el-menu-item index="24"
                                      v-if="isMenuVIf[9]">
                          <span><B>
                              <i class="el-icon-box" style="margin-left: 10px"></i>
                            파나티스 박스매핑
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>




                    <router-link to="/qrCode/panartisWayBill">
                        <el-menu-item index="25"
                                      v-if="isMenuVIf[9]">
                          <span><B>
                              <i class="el-icon-document-copy" style="margin-left: 10px"></i>
                            파나티스 운송장매핑
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>




                    <router-link to="/qrCode/heliodDetailList">
                        <el-menu-item index="26"
                                      v-if="isMenuVIf[10]">
                          <span><B>
                              <i class="el-icon-document-copy" style="margin-left: 10px"></i>
                            헬리오드 운송장매핑
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>


                    <router-link to="/qrCode/jmbiotechCustomer">
                        <el-menu-item index="27"
                                      v-if="isMenuVIf[11]">
                          <span><B>
                              <i class="el-icon-s-custom" style="margin-left: 10px"></i>
                            제이엠바이오텍 고객정보
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>


                    <router-link to="/qrCode/jmbiotechMapping">
                        <el-menu-item index="28"
                                      v-if="isMenuVIf[11]">
                          <span><B>
                              <i class="el-icon-document-copy" style="margin-left: 10px"></i>
                            제이엠바이오텍 운송장
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>



                    <router-link to="/qrCode/koruCustomer">
                        <el-menu-item index="29"
                                      v-if="isMenuVIf[12]">
                          <span><B>
                              <i class="el-icon-s-custom" style="margin-left: 10px"></i>
                           Customer Information
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>


                    <router-link to="/qrCode/koruMapping">
                        <el-menu-item index="30"
                                      v-if="isMenuVIf[12]">
                          <span><B>
                              <i class="el-icon-document-copy" style="margin-left: 10px"></i>
                            Mapping QR Codes
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>



                    <router-link to="/qrCode/kt&gItemInfo">
                        <el-menu-item index="31"
                                      v-if="isMenuVIf[13]">
                          <span><B>
                              <i class="el-icon-document-copy" style="margin-left: 10px"></i>
                             kt&g 품목 추가
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>



                    <router-link to="/qrCode/kt&gDetailList">
                        <el-menu-item index="32"
                                      v-if="isMenuVIf[13]">
                          <span><B>
                              <i class="el-icon-document-copy" style="margin-left: 10px"></i>
                            kt&g 출고 등록
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>


                    <router-link to="/qrCode/GlobientCustomerInfo">
                        <el-menu-item index="35"
                                      v-if="isMenuVIf[15]">
                          <span><B>
                              <i class="el-icon-document-copy" style="margin-left: 10px"></i>
                             Globient 판매처 정보
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>


                    <router-link to="/qrCode/GlobientItemInfo">
                        <el-menu-item index="33"
                                      v-if="isMenuVIf[14]">
                          <span><B>
                              <i class="el-icon-document-copy" style="margin-left: 10px"></i>
                             Globient 품목 추가
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>


                    <hr style=" background-color : white;" width="180"   v-if="isMenuVIf[14]"  />

                    <router-link to="/qrCode/GlobientDetailList">
                        <el-menu-item index="34"
                                      v-if="isMenuVIf[14]">
                          <span><B>
                              <i class="el-icon-document-copy" style="margin-left: 10px"></i>
                            Globient 제조사 박스 매핑
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>


                    <router-link to="/qrCode/GlobientDetailList2">
                        <el-menu-item index="36"
                                      v-if="isMenuVIf[14]">
                          <span><B>
                              <i class="el-icon-document-copy" style="margin-left: 10px"></i>
                            Globient 낱개 개별 출고
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>

                    <hr style=" background-color : white;" width="180"   v-if="isMenuVIf[15]"  />


                    <router-link to="/qrCode/GlobientDetailList3">
                        <el-menu-item index="37"
                                      v-if="isMenuVIf[15]">
                          <span><B>
                              <i class="el-icon-document-copy" style="margin-left: 10px"></i>
                            Globient 물류 출고
                          </B>
                          </span>
                        </el-menu-item>
                    </router-link>

                    <hr style=" background-color : white;" width="180"    />

                    <router-link to="/data/gps">
                        <el-menu-item index="8"
                                      v-if="isMenuVIf[0]"
                        >
                        <span><B>
                            <i class="el-icon-location-outline" style="margin-left: 10px"></i>
                           GPS BATCH 처리결과
                        </B>
                        </span>
                        </el-menu-item>
                    </router-link>

                    <router-link to="/data/blockedIp">
                        <el-menu-item index="8-1"
                                      v-if="isMenuVIf[0]"
                        >
                        <span><B>
                            <i class="el-icon-lock" style="margin-left: 10px"></i>
                           BLOCKED IP
                        </B>
                        </span>
                        </el-menu-item>
                    </router-link>

                    <router-link to="/data/healthRestart">
                        <el-menu-item index="8-2"
                                      v-if="isMenuVIf[0]"
                        >
                        <span><B>
                            <i class="el-icon-refresh" style="margin-left: 10px"></i>
                           HEALTH RESTART
                        </B>
                        </span>
                        </el-menu-item>
                    </router-link>

                    <el-menu-item index="17" @click="logOut">
          <span
          ><b>
              <i class="icon-menu">
                <span class="menu-icon is-mask ic-logout"></span>
              </i>
              로그 아웃</b
          >
          </span>
                    </el-menu-item>
                </el-menu>
            </el-row>
            <!-- left end-->

            <!-- body -->
            <el-container>
                <el-main>
                    <!-- router main -->
                    <router-view />
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isTitleIf: this.$store.state.isTitleVIf,
            isMenuVIf: [],
            isLogoIf : true,
            isLogoIf173 : false,
            isLogoIf174 : false,

        };
    },

    created() {
        // this.isMenuVIf=false;
        //this.isTitleIf=this.$store.state.isTitleVIf;
        if(this.$store.state.accessToken == null || this.$store.state.accessToken == "")
        {
            this.$router.push({ name: 'Login' })
        }

        this.$router.push({ name: 'rightMain' })
        console.log("======created=============="+this.$store.state.accessToken+"=============================");

        for(var  i in this.isMenuVIf){
            this.isMenuVIf[i] = false;
        }

        if (this.$store.state.accessToken == '100' ) {

            this.isMenuVIf[0] = true;
            this.isMenuVIf[1] = true;
            this.isMenuVIf[2] = true;
            this.isMenuVIf[3] = true;
            this.isMenuVIf[4] = true;
            this.isMenuVIf[5] = true;
            this.isMenuVIf[6] = true;


            this.isMenuVIf[7] = true;
            this.isMenuVIf[8] = true;
            this.isMenuVIf[9] = true;
            this.isMenuVIf[10] = true;
            this.isMenuVIf[11] = true;
            this.isMenuVIf[12] = true;

            this.isMenuVIf[13] = true;
            this.isMenuVIf[14] = true;
            this.isMenuVIf[15] = true;

        }

        else if (this.$store.state.accessToken == '2')  // 발행은 발행 메뉴만
        {

            this.isMenuVIf[0] = false;
            this.isMenuVIf[1] = true;
            this.isMenuVIf[2] = false;
            this.isMenuVIf[3] = true;

            if (this.$store.state.userId == 'daeyoung') {
                this.isMenuVIf[1] = false;

                this.isMenuVIf[2] = true;  // daeyoung 입출고
                this.isMenuVIf[3] = true;
            }


            if (this.$store.state.userId == 'classeum' || this.$store.state.userId == 'classeum2') {
                this.isMenuVIf[1] = false;
                this.isMenuVIf[3] = true;
                this.isMenuVIf[4] = true;   //classeum 박스매핑
            }


            if (this.$store.state.userId == 'lemonbottle') {
                this.isMenuVIf[1] = false;
                this.isMenuVIf[3] = true;
                this.isMenuVIf[5] = true;   //classeum 박스매핑
            }


            if (this.$store.state.userId == 'gernetic') {
                this.isMenuVIf[1] = false;
                this.isMenuVIf[3] = true;
                this.isMenuVIf[6] = true;   //classeum 박스매핑
            }


            // 62넥스트플레이 본사  69물류  70,71 면세 ,  72,73,74

            if (this.$store.state.rfid_get_order_seq == 62) {

                this.isMenuVIf[1] = false;
                this.isMenuVIf[3] = true;
                this.isMenuVIf[7] = true;   //classeum 박스매핑
                this.isMenuVIf[8] = true;   //
            }

            if (this.$store.state.rfid_get_order_seq == 68) {

                this.isMenuVIf[1] = false;
                this.isMenuVIf[3] = false;
                this.isMenuVIf[7] = true;   //classeum 박스매핑

            }


            if (this.$store.state.rfid_get_order_seq == 69 || this.$store.state.rfid_get_order_seq == 70
                || this.$store.state.rfid_get_order_seq == 71 || this.$store.state.rfid_get_order_seq == 72 || this.$store.state.rfid_get_order_seq == 73) {

                this.isMenuVIf[1] = false;
                this.isMenuVIf[3] = false;
                //classeum 박스매핑
                this.isMenuVIf[8] = true;
            }


            if (this.$store.state.userId == 'panartis' || this.$store.state.userId == 'panartis') {
                this.isMenuVIf[1] = false;
                this.isMenuVIf[3] = true;
                this.isMenuVIf[9] = true;   //classeum 박스매핑
            }


            if (this.$store.state.userId == 'heliod' || this.$store.state.userId == 'heliod') {
                this.isMenuVIf[1] = false;
                this.isMenuVIf[3] = true;
                this.isMenuVIf[10] = true;   //classeum 박스매핑
            }

            if (this.$store.state.rfid_get_order_seq == 5 || this.$store.state.userId == 'jmbio') {

                this.isMenuVIf[1] = false;
                this.isMenuVIf[3] = true;
                this.isMenuVIf[11] = true;   //classeum 박스매핑
            }


            if (this.$store.state.rfid_get_order_seq == 130 || this.$store.state.userId == 'Korupharma') {

                this.isMenuVIf[1] = false;
                this.isMenuVIf[3] = true;
                this.isMenuVIf[12] = true;   //classeum 박스매핑
            }


            if (this.$store.state.rfid_get_order_seq == 173 ) {

                this.isMenuVIf[1] = false;
                this.isMenuVIf[3] = true;
                this.isMenuVIf[13] = true;   //ktng 박스매핑

                this.isLogoIf = false;
                this.isLogoIf173 = true;


            }

            if (this.$store.state.rfid_get_order_seq == 174 ) {

                this.isMenuVIf[1] = false;
                this.isMenuVIf[3] = true;
                this.isMenuVIf[14] = true;   //글로비스 박스매핑
                this.isMenuVIf[15] = true;   //글로비스 박스매핑

                this.isLogoIf = false;
                this.isLogoIf174 = true;

            }

            if (this.$store.state.rfid_get_order_seq == 181 ) {


                this.isMenuVIf[1] = false;
                this.isMenuVIf[3] = false;
                this.isMenuVIf[15] = true;   //글로비스 박스매핑
                this.isLogoIf = false;
                this.isLogoIf174 = true;

            }

            if (this.$store.state.rfid_get_order_seq == 182 ) {

                this.isMenuVIf[1] = false;
                this.isMenuVIf[3] = false;
                this.isMenuVIf[14] = true;   //글로비스 박스매핑
                this.isLogoIf = false;
                this.isLogoIf174 = true;

            }

        }
    },


    destroyed() {
        console.log("==========destroyed==============");
    },

    beforeDestroy() {
        console.log("beforeDestroy");
        this.$store.commit("setAccessToken", "");
    },

    methods: {
        handleOpen(key, keyPath) {
            console.log("handleOpen");
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log("handleClose");
            console.log(key, keyPath);
        },



        logOut() {
            this.$store.commit("setAccessToken", "");
            this.$store.commit("setDeptSeq", "");
            this.$store.commit("setUserId", "");
            this.$store.commit("setDeptName", "");
            this.$store.commit("setAddress1", "");
            this.$store.commit("setAddress2", "");

            this.$notify.success({
                title: "LOG OUT ",
                position: "bottom-right",
                duration: 1500,
            });

            this.$router.push({ name: "Login" });
        },
    },
};
</script>

<style>
.tac.el-row {
    background-color: #fff;
    margin-bottom: 0;
    margin-left: 1rem !important;
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
    border-radius: 0.5rem !important;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.03), 0 10px 20px rgba(0, 0, 0, 0.02) !important;
}
.tac.el-row div {
    background-color: #fff !important;
}
.el-aside {
    color: #013263;
}
.el-submenu__title {
    font-size: 13px !important;
}
.el-menu {
    border: none !important;
}
.el-menu-item [class^="el-icon-"] {
    vertical-align: baseline !important;
}
.searchTitle2 {
    width: 200px !important;
    height: 40px !important;
    font-size: 50px !important;
    align-items: center !important;
    margin-left: 10px !important;
    padding: 10px !important;
    display: flex !important;
    white-space: nowrap;
    color: rgb(1, 50, 99);
}

#searchTitle2 {
    width: 200px !important;
    height: 40px !important;
    font-size: 50px !important;
    align-items: center !important;
    margin-left: 10px !important;
    padding: 10px !important;
    display: flex !important;
    white-space: nowrap;
    color: rgb(1, 50, 99);
}
#bigo {
    height: 20px !important;
    width: 280px !important;
    border: 1px solid #2C5AA0 !important;
    border-radius: 4px !important;
    box-sizing: border-box !important;
    font-size: 9px !important;
    cursor: pointer !important;
    padding: 0 6px !important;
}
.el-button--primary {
    font-size: 10px !important;
}
.el-table th > .cell {
    font-size: 10px;
    white-space: nowrap;
}
.el-table__empty-text {
    font-size: 10px;
}
.el-table--border,
.el-table--group {
    border: none !important;
}
.el-table--border::after,
.el-table--group::after,
.el-table::before {
    background-color: transparent !important;
}
.el-table__empty-block {
    background-color: #f1f3fa;
}
.el-date-picker__header {
    padding: 12px;
    margin: 0 !important;
    background-color: #013263;
    border-radius: 0.75rem 0.75rem 0 0;
}
.el-picker-panel {
    border-radius: 0.75rem !important;
}
.el-popper[x-placement^="bottom"] .popper__arrow::after {
    border-bottom-color: #013263 !important;
}
.el-picker-panel__icon-btn,
.el-date-picker__header-label {
    color: #fff !important;
}
.el-menu-item.is-active {
    color: #fff !important;
    background: #409eff !important;
}
.el-menu-item i::before {
    font-size: 14px !important;
    margin-left: 4px;
}
.pagination {
    justify-content: center !important;
}
.icon-menu img {
    margin: 0 7px;
} /* 기존 img 아이콘 여백 유지 */
label {
    margin-bottom: 0 !important;
}
.el-menu-item,
.el-submenu__title {
    height: 36px !important;
    display: flex !important;
    align-items: center !important;
}
.el-menu-item {
    font-size: 12px !important;
    display: flex !important;
    margin: 0px 8px !important;
    padding: 0px !important;
    color: rgb(1, 50, 99) !important;
    background: #fff !important;
    border-radius: 0.375rem;
    padding-right: 8px !important;
}
.el-menu-vertical-demo.el-menu {
    background: #fff !important;
}
.el-submenu__icon-arrow {
    right: 30px !important;
}
a {
    text-decoration: none !important;
}
.element.style {
    padding-left: 40px;
    color: rgb(255, 208, 75);
    background-color: rgb(1, 50, 99);
}
.el-submenu__title {
    width: 156px !important;
}

/* ====== 추가: 4개 아이콘 mask 방식 / 색상 전환 / 사이즈 축소 ====== */
.menu-icon.is-mask {
    display: inline-block;
    width: 32px;
    height: 32px;
    background-color: #697a8d; /* 기본 색 */
    /* mask 설정 */
    -webkit-mask-image: var(--icon-url);
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    -webkit-mask-size: contain;
    mask-image: var(--icon-url);
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;

    margin: 0 5px;
    vertical-align: middle;
    transition: background-color 0.2s ease;
}

/* 선택(활성) 상태에서도 흰색 유지(가독성) */
.el-menu-item.is-active .menu-icon.is-mask {
    background-color: #fff;
}

/* 각 아이콘 파일 매핑 */
.ic-bookloc {
    --icon-url: url("./resource/ic_bookloc.svg");
}

.ic-ai {
    --icon-url: url("./resource/chatGpt.png");
}

.ic-asset {
    --icon-url: url("./resource/ic_asset.svg");
}

.ic-borrower {
    --icon-url: url("./resource/ic_borrower.svg");
}

.ic-docloan {
    --icon-url: url("./resource/ic_docloan.svg");
}

.ic-docloan-history {
    --icon-url: url("./resource/ic_docloan_history.svg");
}

.ic-inventory-result {
    --icon-url: url("./resource/ic_inventory_result.svg");
}

.ic-doctype-manage {
    --icon-url: url("./resource/ic_doctype_manage.svg");
}


.ic-docloan-unregistered {
    --icon-url: url("./resource/ic_docloan_unregistered.svg");
}



.ic-admin {
    --icon-url: url("./resource/ic_admin.svg");
}

.ic-logout {
    --icon-url: url("./resource/ic_logout.svg");
}



.ic-product-master {
    --icon-url: url("./resource/Master-Create.svg");
}
.ic-rfid-issue-request {
    --icon-url: url("./resource/Issue-Request.svg");
}
.ic-rfid-issue-confirm {
    --icon-url: url("./resource/Issue-Confirm.svg");
}
.ic-rfid-issue-download {
    --icon-url: url("./resource/Issue-Download.svg");
}
.ic-production-inbound {
    --icon-url: url("./resource/Production-Inbound.svg");
}
.ic-production-shipping {
    --icon-url: url("./resource/Production-Shipping.svg");
}
.ic-logistics-inbound {
    --icon-url: url("./resource/Logistics-Inbound.svg");
}
.ic-logistics-shipping {
    --icon-url: url("./resource/Logistics-Shipping.svg");
}
.ic-store-inbound {
    --icon-url: url("./resource/Store-Inbound.svg");
}
.ic-store-shipping {
    --icon-url: url("./resource/Store-Shipping.svg");
}
.ic-add-production {
    --icon-url: url("./resource/Add-Production.svg");
}
.ic-history-manage {
    --icon-url: url("./resource/history-manage.svg");
}
.ic-add-user {
    --icon-url: url("./resource/User-Account.svg");
}
.ic-logout-exit {
    --icon-url: url("./resource/Logout-Exit.svg");
}
</style>
